module.exports = "/images/vendor/flag-icon-css/flags/1x1/ni.svg?baafd7d7fc1b69642270c1c1fee58bed";